"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselActions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("../../icons");
var CarouselActions = function (_a) {
    var activeIndex = _a.activeIndex, arrowPosition = _a.arrowPosition, arrowRounded = _a.arrowRounded, infinite = _a.infinite, overlay = _a.overlay, pagination = _a.pagination, prev = _a.prev, next = _a.next, pageCount = _a.pageCount;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(reactstrap_1.Button, __assign({ "data-testid": "carousel-prev", color: (0, classnames_1.default)(overlay ? 'light btn-carousel-overlay' : 'standard-outline'), className: (0, classnames_1.default)("btn-square rounded-".concat(arrowRounded), overlay
                    ? 'position-absolute top-50 start-0 translate-middle-y ms-5'
                    : arrowPosition === 'center' && pagination && 'me-5'), onClick: prev, disabled: !infinite && activeIndex === 0 }, { children: [(0, jsx_runtime_1.jsx)(icons_1.Left24, { className: "absolute-center", "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)("span", __assign({ className: "visually-hidden" }, { children: "Previous" }))] })), (0, jsx_runtime_1.jsxs)(reactstrap_1.Button, __assign({ "data-testid": "carousel-next", color: overlay ? 'light btn-carousel-overlay' : 'standard-outline', className: (0, classnames_1.default)("btn-square rounded-".concat(arrowRounded), overlay
                    ? 'position-absolute top-50 end-0 translate-middle-y me-5'
                    : arrowPosition === 'center'
                        ? 'ms-5 order-2'
                        : 'ms-4'), onClick: next, disabled: !infinite && activeIndex === pageCount - 1 }, { children: [(0, jsx_runtime_1.jsx)(icons_1.Right24, { className: "absolute-center" }), (0, jsx_runtime_1.jsx)("span", __assign({ className: "visually-hidden" }, { children: "Next" }))] }))] }));
};
exports.CarouselActions = CarouselActions;
